/**
 * Loader interface.
 *
 * A Loader pulls in data and outputs it to a container based on a template.
 * Abstract class that should be extended and not directly implemented.
 */
export default class Loader {
    /**
     * Combine the template with the data to get final output.
     * @param string template Template content.
     * @param mixed  data     Data to pass into the template.
     * @return string
     */
    compile(template, data) {
        throw new TypeError(this.constructor.name + ' must implement the `compile` method');
    }

    /**
     * Output the combined template and data content to the container.
     * @param string containerId ID of element container.
     * @param string templateId  Template content container.
     * @param mixed  data        Data to pass into the template.
     * @return string
     */
    render(containerId, templateId, data) {
        throw new TypeError(this.constructor.name + ' must implement the `render` method');
    }

    /**
     * Load the data into to the container using the template.
     * @param string  containerId ID of element container.
     * @param string  templateId  Template content container.
     * @param mixed   data        Data to pass into the template.
     * @param Closure process     Callback on data to format before passing into template.
     * @return string
     */
    load(containerId, templateId, data, process) {
        throw new TypeError(this.constructor.name + ' must implement the `load` method');
    }
}
